import { startOfMonth, addMonths, isAfter, format, startOfYear, endOfYear, min, max, } from 'date-fns';
export const getMonthsListWithYearsBetweenDates = (startDate, endDate, shownYear = new Date().getFullYear()) => {
    const months = [];
    let adjustedStartDate;
    let adjustedEndDate;
    if (shownYear === 0) {
        // "All time" should reflect the real offer range.
        adjustedStartDate = startOfMonth(startDate);
        adjustedEndDate = startOfMonth(endDate);
    }
    else {
        const startOfShownYear = startOfYear(new Date(shownYear, 0, 1));
        const endOfShownYear = endOfYear(new Date(shownYear, 0, 1));
        adjustedStartDate = startOfMonth(max([startDate, startOfShownYear]));
        adjustedEndDate = startOfMonth(min([endDate, endOfShownYear]));
    }
    if (isAfter(adjustedStartDate, adjustedEndDate)) {
        return [];
    }
    let currentDate = adjustedStartDate;
    while (!isAfter(currentDate, adjustedEndDate)) {
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        months.push({
            key: format(currentDate, 'yyyy-MM'),
            name: format(currentDate, 'MMMM').toLowerCase(),
            month,
            year,
        });
        currentDate = addMonths(currentDate, 1);
    }
    return months;
};
